import {
  FETCH_RESOURCE_REQUEST,
  UPDATE_RESOURCE_REQUEST,
  UPDATE_RESOURCE_PASSWORD_REQUEST,
  TOGGLE_RESOURCE_MEETING_MODAL,
} from './resourceActionTypes';

export const fetchResource = () => {
  return {
    type: FETCH_RESOURCE_REQUEST,
  };
};

export const updateResource = (params) => {
  return {
    type: UPDATE_RESOURCE_REQUEST,
    params,
  };
};

export const updateResourcePassword = (params) => {
  return {
    type: UPDATE_RESOURCE_PASSWORD_REQUEST,
    params,
  };
};

export const toggleShowResourceMeetingModal = (visible) => {
  return {
    type: TOGGLE_RESOURCE_MEETING_MODAL,
    visible,
  };
};
